/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import dataSuccess from 'data/dataSuccess';
import Amount from 'components/Amount';
import SuccessPage from 'components/success/SuccessPage';
import CommentBlock from 'components/success/CommentBlock';
import PrimeBlock from 'components/success/PrimeBlock';
import { normalizeAmount } from 'utils/normalizeAmount';

class SuccessAudit extends React.Component {
  render() {
    const APIresult = this.props.result.data;
    const price1 = normalizeAmount(APIresult['Coût travaux unitaire (€)']);
    const price3 = normalizeAmount(APIresult['Reste à charge unitaire (€)']);
    const pricePromo = normalizeAmount(APIresult['Coût travaux promotion (€)']);
    const priceBase = normalizeAmount(APIresult['Coût de départ travaux (€)']);
    const valeurMax = APIresult['Valeur max'];
    const coutTravaux = pricePromo || price1;
    const resteAPayer = this.props.resultCodePromo?.data?.reste_a_charge
      ? this.props.resultCodePromo.data.reste_a_charge
      : price3;
    const isDPE = this.props.answers.Q1 === 'diagnosticLogement';
    const surDevis = price1 === 0;

    return (
      <SuccessPage {...this.props}>
        {surDevis ? (
          <>
            <CommentBlock>
              <p className="!-mt-2 text-[14px]/[20px]">
                Pour les surfaces dépassant {valeurMax}&nbsp;m², nous vous
                proposons un devis sur-mesure, dès <Amount value={priceBase} />.
              </p>
            </CommentBlock>
          </>
        ) : (
          <>
            <div
              className={clsx('success-item-right', {
                'no-border': resteAPayer === coutTravaux,
              })}
            >
              <h5>
                {isDPE ? (
                  <>Estimation coût du projet</>
                ) : (
                  <>Coût de l’audit énergétique</>
                )}
              </h5>
              <div>
                {!pricePromo ? (
                  <h5 className="h5-price text-gris-hellio whitespace-nowrap">
                    <Amount value={price1} />
                    <span
                      className={
                        this?.props?.answers?.Q48 === 'Audit règlementaire'
                          ? ''
                          : 'is-hidden'
                      }
                      style={{ fontSize: '14px' }}
                    >
                      {' '}
                      TTC
                    </span>
                  </h5>
                ) : (
                  <div>
                    <h2 className="whitespace-nowrap">
                      <del>
                        <Amount value={price1} />
                      </del>
                    </h2>
                    <h1
                      style={{ lineHeight: '1em' }}
                      className="text-sub2 whitespace-nowrap"
                    >
                      <Amount value={pricePromo} />{' '}
                      {dataSuccess[this.props.success].showM2 && (
                        <span className="second">/ m²</span>
                      )}
                    </h1>
                  </div>
                )}
              </div>
            </div>
            {!!pricePromo && (
              <p className="text-sub2 is-light text-s mt-5">
                <i>
                  offre limitée jusqu&apos;au <strong>31 Mars 2023</strong>
                </i>
              </p>
            )}
            <PrimeBlock
              APIresult={APIresult}
              success={this.props.success}
              resultCodePromo={this.props.resultCodePromo}
            />

            {resteAPayer !== coutTravaux && (
              <div>
                <div className="success-item-right last">
                  <h5>Reste à payer audit</h5>
                  <div>
                    <h5 className="h5-price whitespace-nowrap">
                      <Amount value={resteAPayer} />
                    </h5>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </SuccessPage>
    );
  }
}

export default SuccessAudit;
